/**
 * @format
 */
import { api } from '@/scripts/api';

export const JourneyService = {
    get(params = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/JourneyAnalytics';
            const endpoint = api.applyODataParams(service, params);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getJourneys(params = {}) {
        return new Promise((resolve, reject) => {
            const service = '/service/Journeys';
            const endpoint = api.applyODataParams(service, params);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getTemplate(params = {}, signal) {
        return new Promise((resolve, reject) => {
            const service = '/service/JourneyTemplates/';
            const endpoint = api.applyODataParams(service, params);
            api.get(endpoint, signal)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                });
        });
    },

    post(query = '', payload = {}) {
        return new Promise((resolve, reject) => {
            const service = `/api/Journeys/${query}`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    postTemplate(query = '', payload = {}) {
        return new Promise((resolve, reject) => {
            const service = `/api/JourneyTemplates/${query}`;
            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    patch(id, changes) {
        return new Promise((resolve, reject) => {
            const service = `/api/Journeys/${id}`;

            api.patch(service, changes).then(resolve).catch(reject);
        });
    },

    patchList(id, changes) {
        return new Promise((resolve, reject) => {
            const service = `/api/Journeys/${id}/Lists`;

            api.patch(service, changes).then(resolve).catch(reject);
        });
    },

    patchTemplate(id, changes) {
        return new Promise((resolve, reject) => {
            const service = `/api/JourneyTemplates/${id}`;

            api.patch(service, changes).then(resolve).catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Journeys/${id}`;
            api.delete(service).then(resolve).catch(reject);
        });
    },
    deleteTemplates(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/JourneyTemplates/${id}`;
            api.delete(service).then(resolve).catch(reject);
        });
    },
};
